import { sql } from 'drizzle-orm';
import {
  pgTable,
  index,
  jsonb,
  timestamp,
  varchar,
  text,
  uuid,
} from "drizzle-orm/pg-core";
import { claims } from './claims';
import { documents } from './documents';
import { organizations } from './organizations';
import { users } from './users';
import { postalJobStatusEnum, postalMailClassEnum } from './enums';


// ============================================================================
// Letterstream Jobs — tracks each certified mail send
// ============================================================================

export const letterstreamJobs = pgTable("letterstream_jobs", {
  id: uuid("id").primaryKey().default(sql`gen_random_uuid()`),

  // Claim and document association
  claimId: uuid("claim_id").references(() => claims.id, { onDelete: "cascade" }).notNull(),
  documentId: uuid("document_id").references(() => documents.id, { onDelete: "set null" }),

  // Letterstream tracking
  letterstreamJobId: varchar("letterstream_job_id"), // Job ID returned by Letterstream API
  mailClass: postalMailClassEnum("mail_class").notNull().default("certified"),
  status: postalJobStatusEnum("status").notNull().default("pending"),

  // Recipient information (denormalised at send time for audit trail)
  recipientName: varchar("recipient_name").notNull(),
  recipientAddress: text("recipient_address").notNull(),
  recipientCity: varchar("recipient_city").notNull(),
  recipientState: varchar("recipient_state").notNull(),
  recipientZip: varchar("recipient_zip").notNull(),

  // Tracking
  trackingNumber: varchar("tracking_number"),
  mailedAt: timestamp("mailed_at"),
  deliveredAt: timestamp("delivered_at"),

  // Webhook lifecycle
  lastWebhookAt: timestamp("last_webhook_at"),
  webhookEvents: jsonb("webhook_events").$type<Array<Record<string, unknown>>>(), // Raw webhook payloads

  // Status details
  statusReason: text("status_reason"), // Error message or return reason

  // Audit
  createdBy: varchar("created_by").references(() => users.id),
  orgId: uuid("org_id").references(() => organizations.id, { onDelete: "cascade" }),

  createdAt: timestamp("created_at").defaultNow(),
  updatedAt: timestamp("updated_at").defaultNow(),
}, (table) => [
  index("idx_letterstream_jobs_claim_id").on(table.claimId),
  index("idx_letterstream_jobs_letterstream_job_id").on(table.letterstreamJobId),
  index("idx_letterstream_jobs_status").on(table.status),
]);
